<template>
  <main>
    <div class="container-fluid mt-3" style="max-width: 800px;">
      <div class="row mb-3 g-3 mt-3">
        <div class="col">
          <h5><strong>Seus Pedidos</strong></h5>
          <div class="a-divider a-divider-break"></div>
        </div>
      </div>
      <div class="row m-3" v-if="erro">
        <div
          class="col card my-2 badge-danger text-center p-3 text-uppercase mt-3"
        >
          {{ erro }}
        </div>
      </div>
      <ListarPedidos :obj-pedidos="objPedidos" v-if="!loading" />

      <div class="row m-3" v-if="objPedidos.length == 0">
        <div class="col text-center p-3 text-uppercase mt-3">
          NENHUM PEDIDOS FOI LOCALIZADO!
        </div>
      </div>
      <Loading v-if="loading"></Loading>
    </div>
  </main>
</template>

<script>
// @ is an alias to /src
import { APIService } from '../APIService'
import Loading from '@/components/Loading.vue'
const apiService = new APIService()
import ListarPedidos from '../components/pedidos/ListarPedidos'

export default {
  name: 'Pedido',
  components: {
    ListarPedidos,
    Loading,
  },
  data() {
    return {
      objPedidos: null,
      idPedido: 0,
      loading: true,
      erro: '',
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.loading = true
    apiService
      .getListarPedidos()
      .then((response) => {
        this.objPedidos = response
        this.loading = false
      })
      .catch((error) => {
        this.erro = error.response.data.title
        this.loading = false
        window.scrollTo(0, 0)
      })
  },
  methods: {},
}
</script>
<style scoped lang="scss"></style>
